import React, { useEffect, useState} from 'react'
import "../styles/header_style.css"
import mainLogo from '../images/wwn_logo.png'
import lightning from '../images/wwn_lightning.png'
import navButtonImage from '../images/Nav_Button_Image.png'
import { Link } from "react-router-dom"


const Header = () => {

    const classificationId = ["b","g","a","p4pb"];



  return (
    <div class="header_parent">
        <div className="header">
            <div id='header_images'>
                <img src={lightning} id='header_lightning' alt="" />
                <img src={mainLogo} id="header_logo" alt="" />
            </div>
        </div>
        <nav class="" id='navbar'>
            {/* orange button container  */}
            {/* <div id="nav_left_container" class="col-2">
                <h1>home</h1>
            </div> */}
            {/* green center container  */}
            <div id="nav_center_container" class="">
                {/* Boys Dropdown  */}
                <Link className="link_styles" to="/">
                    <img class="nav_button_image" src={navButtonImage} alt="Nav Button Image" />
                    <button class="nav_button nav_button_long">HOME</button>
                    <button class="nav_button nav_button_short">HOME</button>
                </Link>
                <div class="dropdown">
                    <Link class="link_styles" to={`/rankings/${classificationId[0]}`}>  
                        <img className="nav_button_image" src={navButtonImage} alt="Nav Button Image" />
                        <button class="dropbtn nav_button nav_button_long"> 
                            BOYS RANKINGS
                        </button>
                        <button class="dropbtn nav_button nav_button_short"> 
                            BOYS
                        </button>
                    </Link>
                    <div class="dropdown-content">
                        <a href="/rankings/b/as/106">All State</a>
                        <a href="/rankings/b/4ab/106">4A</a>
                        <a href="/rankings/b/3ab/106">3A</a>
                        <a href="/rankings/b/2ab/106">2A</a>
                        <a href="/rankings/b/1ab/106">1A</a>
                        <a href="/rankings/b/bb/106">B</a>
                        {/* <a href="/rankings/cs">B</a> */}
                    </div>
                </div>
                {/* Girls Dropdown  */}
                <div class="dropdown">
                    <Link class="link_styles" to={`/rankings/${classificationId[1]}`}>
                        <img className="nav_button_image" src={navButtonImage} alt="Nav Button Image" />
                        <button class="dropbtn nav_button nav_button_long">
                                GIRLS RANKINGS
                        </button>
                        <button class="dropbtn nav_button nav_button_short">
                                GIRLS
                        </button>
                    </Link>
                    <div class="dropdown-content">
                        <a href="/rankings/g/as/100">All State</a>
                        <a href="/rankings/g/4ag/100">4A</a>
                        <a href="/rankings/g/3ag/100">3A</a>
                        <a href="/rankings/g/2ag/100">2A</a>
                        <a href="/rankings/g/1a1b2bg/100">1A/1B/2B</a>
                    </div>
                </div>
                {/* All Class Dropdown */}
                <div class="dropdown">
                    <Link class="link_styles" to={`/rankings/${classificationId[3]}`}>
                        <img className="nav_button_image" src={navButtonImage} alt="Nav Button Image" />
                        <button class="dropbtn nav_button nav_button_long">
                            POUND FOR POUND
                        </button>
                        <button class="dropbtn nav_button nav_button_short">
                            P4P
                        </button>
                    </Link>
                    
                    <div class="dropdown-content">
                        <a href="/rankings/p4pb">Boys</a>
                        <a href="/rankings/p4pg">Girls</a>
                    </div>
                </div>
                <Link className="link_styles" to="/wwnteam">
                    <img className="nav_button_image" src={navButtonImage} alt="Nav Button Image" />
                    <button class="nav_button nav_button_long"> WWN TEAM </button>
                    <button class="nav_button nav_button_short">WWN</button>
                </Link>
            </div>
            {/* yellow container  */}
            {/* <div id="nav_right_container" class="col-2">

                <div class="nav_button col-9">
                    WWN TEAM
                </div>
            </div> */}
            {/* <ul class="flex">
                <li class="nav_button"><p>Home</p></li>
                <li class="nav_button"><p>Boys Rankings</p></li>
                <li class="nav_button"><p>Girls Rankings</p></li>
                <li class="nav_button"><p>All Class Rankings</p></li>
                <li class="nav_button"><p>About Us</p></li>
            </ul> */}
        </nav>




    </div>
  )
}

export default Header